import React from "react";
import { Box, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

const Icon = ({ value }) => {
    if (typeof value !== "boolean") {
        return (
            <Typography sx={{ fontWeight: 500, fontSize: { xs: 11, md: 14 }, fontFamily: "Poppins, sans-serif" }}>
                {value}
            </Typography>
        );
    }

    return value ? (
        <CheckCircleIcon sx={{ color: "#4CAF50" }} />
    ) : (
        <CancelIcon sx={{ color: "#E57373" }} />
    );
};

const Row = ({ label, left, right }) => (
    <Box
        sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr 1fr 1fr", md: "1.2fr 1fr 1fr" },
            borderBottom: "1px solid #eee"
        }}
    >
        <Box sx={{ p: "16px 20px" }}>
            <Typography sx={{ color: "#6b6b6b", fontSize: { xs: 12, md: 14 }, fontFamily: "Poppins, sans-serif" }}>
                {label}
            </Typography>
        </Box>

        <Box sx={{ p: "16px 20px", textAlign: "center" }}>
            <Icon value={left} />
        </Box>

        <Box
            sx={{
                p: "16px 20px",
                textAlign: "center",
                background: {
                    xs: "linear-gradient(180deg, rgba(123,63,228,0.06), rgba(123,63,228,0.12))",
                    md: "linear-gradient(180deg, rgba(123,63,228,0.06), rgba(123,63,228,0.12))"
                }
            }}
        >
            <Icon value={right} />
        </Box>
    </Box>
);

const Section = ({ title }) => (
    <Box
        sx={{
            fontSize: { xs: 10, md: 12 },
            letterSpacing: 1,
            color: "#9e9e9e",
            fontWeight: 600,
            p: "10px 20px",
            background: "#fafafa"
        }}
    >
        {title}
    </Box>
);

export default function Pricing() {
    return (
        <Box sx={{ margin: "50px auto", width: { xs: "90%", md: "70%" }}}>

            <Typography
                variant="h4"
                sx={{ fontWeight: "700", mb: 3, fontSize: {xs:"1.5rem", md: "2rem"} }}
            >
                Bootcamp Fee: Simple, transparent pricing
            </Typography>

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    
                    fontFamily: "'Poppins', sans-serif"
                }}
            >
                <Box
                    sx={{
                        width: '100%',
                        background: "#fff",
                        borderRadius: "20px",
                        overflow: "hidden",
                        boxShadow: "0 10px 40px rgba(0,0,0,0.08)"
                    }}
                >
                    {/* HEADER */}
                    <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns: { xs: "1.2fr 1fr 1fr", md: "1.2fr 1fr 1fr" },
                            borderBottom: "1px solid #eee"
                        }}
                    >
                        <Box />

                        {/* ADVANCE */}
                        <Box sx={{ p: {xs:2.5, md:4}, textAlign: "center" }}>
                            <Typography sx={{ fontSize: { xs: 10, md: 22 }, fontWeight: 600, fontFamily: "Poppins, sans-serif", paddingTop: { xs: 2.5, md: 4.5 } }}>
                                Advance
                            </Typography>
                            <Typography sx={{ fontSize: { xs: 8, md: 13 }, color: "#888", fontFamily: "Poppins, sans-serif" }}>
                                Basic to Intermediate
                            </Typography>

                            <Typography sx={{ fontSize: { xs: 15, md: 32 }, fontWeight: 700, mt: 1, fontFamily: "Poppins, sans-serif" }}>
                                ₹66,999
                            </Typography>
                            <Typography sx={{ fontSize: { xs: 8, md:  12 }, color: "#888", fontFamily: "Poppins, sans-serif" }}>
                                + taxes
                            </Typography>

                            <Typography sx={{ fontSize: { xs: 10 }, color: "#7b3fe4", fontWeight: 600, mt: 1, fontFamily: "Poppins, sans-serif" }}>
                                EMI from ₹8,888/mo
                            </Typography>
                        </Box>

                        {/* PROFESSIONAL */}
                        <Box
                            sx={{
                                p:{xs:2.5, md:4},
                                textAlign: "center",
                                background: "linear-gradient(180deg, rgba(123,63,228,0.06), rgba(123,63,228,0.12))"
                            }}
                        >
                            <Box
                                sx={{
                                    display: "inline-block",
                                    px: { xs: 0.8, md: 1.5 },
                                    py: { xs: 0.2, md: 0.5 },
                                    borderRadius: "12px",
                                    background: "#7b3fe4",
                                    color: "#fff",
                                    fontSize: { xs: 8, md: 11 },
                                    mb: 1,
                                    fontFamily: "Poppins, sans-serif",
                                    fontWeight: 600
                                }}
                            >
                                Most Popular
                            </Box>

                            <Typography sx={{ fontSize: { xs: 10, md: 22 }, fontWeight: 600, fontFamily: "Poppins, sans-serif" }}>
                                Professional
                            </Typography>
                            <Typography sx={{ fontSize: { xs: 8, md: 13 }, color: "#888", fontFamily: "Poppins, sans-serif" }}>
                                Basic to Expert
                            </Typography>

                            <Typography sx={{ fontSize: { xs: 15, md: 32 }, fontWeight: 700, mt: 1, fontFamily: "Poppins, sans-serif" }}>
                                ₹1,04,000
                            </Typography>
                            <Typography sx={{ fontSize: { xs: 8, md:  12 }, color: "#888", fontFamily: "Poppins, sans-serif" }}>
                                + taxes
                            </Typography>

                            <Typography sx={{ fontSize: { xs: 10 }, color: "#7b3fe4", fontWeight: 600, mt: 1, fontFamily: "Poppins, sans-serif" }}>
                                EMI from ₹6,166/mo
                            </Typography>
                        </Box>
                    </Box>

                    {/* CONTENT */}
                    <Section title="OVERVIEW" />
                    <Row label="Duration" left="7 months" right="12 months" />
                    <Row label="Total hours" left="200+ hrs" right="500+ hrs" />

                    <Section title="LEARNING" />
                    <Row label="Projects" left="10" right="20" />
                    <Row label="Case studies" left="10" right="50" />
                    <Row label="Assignments" left="100+ hrs" right="300+ hrs" />
                    <Row label="IIT faculty lectures" left="6" right="12" />

                    <Section title="CAREER SUPPORT" />
                    <Row label="Guaranteed job support" left="6 months" right="12 months" />
                    <Row label="Mock interviews" left="3" right="Unlimited" />
                    <Row label="1:1 mentorship" left={true} right={true} />

                    <Section title="WHAT'S INCLUDED" />
                    <Row label="100% live classes" left={true} right={true} />
                    <Row label="Live workshops" left={false} right={true} />
                    <Row label="IIT kit" left={false} right={true} />
                    <Row label="Grooming session" left={false} right={true} />

                    <Section title="CERTIFICATIONS" />

                    <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns: { xs: "1fr 1fr 1fr", md: "1.2fr 1fr 1fr" },
                        }}
                    >
                        <Box sx={{ p: "16px 20px", fontSize: { xs: 12, md: 14 } }}>
                            You'll receive
                        </Box>

                        <Box sx={{ p: "16px 20px", }}>
                            {[
                                "TIH-IIT Patna",
                                "6-Month Project Experience",
                                "PL Course Completion"
                            ].map((item) => (
                                <Typography key={item} sx={{ fontSize: { xs: 10, md: 14 }, mb: 1, fontFamily: "Poppins, sans-serif" }}>
                                    • {item}
                                </Typography>
                            ))}
                        </Box>

                        <Box
                            sx={{
                                p: "16px 20px",
                                background: {
                                    xs: "linear-gradient(180deg, rgba(123,63,228,0.06), rgba(123,63,228,0.12))",
                                    md: "linear-gradient(180deg, rgba(123,63,228,0.06), rgba(123,63,228,0.12))"
                                }
                            }}
                        >
                            {[
                                "TIH-IIT Patna",
                                "6-Month Project Experience",
                                "PL Course Completion",
                                "Microsoft AZ 104",
                                "AWS Solution Architect"
                            ].map((item) => (
                                <Typography key={item} sx={{ fontSize: { xs: 10, md: 14 }, mb: 1, fontFamily: "Poppins, sans-serif" }}>
                                    • {item}
                                </Typography>
                            ))}
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}